/*
 * @Author: lsh lsh@163.com
 * @Date: 2022-05-17 09:46:17
 * @LastEditors: lsh lsh@163.com
 * @LastEditTime: 2022-05-30 10:52:57
 * @FilePath: /xhj/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
// import homePage from '../views/home1.vue'
import classfiy from '../views/classfiy/index.vue'
// () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const routes = [
  // {
  //   path: "/homePage",
  //   name: "homePage",
  //   component: homePage,
  //   meta: {
  //     keepAlive:true
  //   }
  // },
  {
        path: '/',
        name: 'Home',
        component: Home,
        //需要被缓存
        meta: {
            keepAlive: true
        },
    },
    {
        path: '/classfiy',
        name: 'classfiy',
        component: classfiy
  }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

export default router
